export default "__VITE_ASSET__QU4Egxuf__"